import { makeGraphQLRequest } from '../utils/requestUtils';

export default async function getOrganizationByStatus(status) {
  const query = `query organizationByStatus($status: String){  
    organizationByStatus(iconStatus: $status){  
    organizations{ 
      id
      name
      address1
      address2
      address3
      zipCode
      pointOfContact
      phoneNumber
      industryType
      industryAssociations
      organizationType
      city
      cageCode
      state
      iconStatus
      approvalDate
      admins {name email phoneNumber subscriptionLevel}
    }
  }
  } `;

  const variables = { status };
  const response = await makeGraphQLRequest({
    query,
    variables,
  });

  return response;
}



// WEBPACK FOOTER //
// ./src/graphql/SuperAdmin.js